<template>
  <div class="member-address">
    <div class="add-wrapper">
      <el-button class="btn-add" type="default" round icon="el-icon-plus" @click="onShowAddDlg">
        请添加收货地址
      </el-button>
    </div>
    <div class="list-wrapper">
      <el-row class="title">
        <el-col :span="3">收货人</el-col>
        <el-col :span="5">所在地区</el-col>
        <el-col :span="6">详细地址</el-col>
        <el-col :span="4">电话/手机</el-col>
        <el-col :span="3">操作</el-col>
        <el-col :span="3"></el-col>
      </el-row>
      <EmptyNew v-if="!list.length" title="暂无收获地址"></EmptyNew>
      <el-row class="item" type="flex" v-for="(item, index) in list" :key="index">
        <el-col :span="3">{{ item.user_name }}</el-col>
        <el-col :span="5">
          {{ `${item.province_name} ${item.city_name} ${item.district_name}` }}
        </el-col>
        <el-col :span="6">{{ item.address }}</el-col>
        <el-col :span="4">{{ item.mobile }}</el-col>
        <el-col :span="3" class="action">
          <p class="btn" @click="onModify(item)">修改</p>
          <p class="btn" @click="onDelete(item)">删除</p>
        </el-col>
        <el-col :span="3" class="default">
          <p v-if="item.is_default == 1" class="tag-default">默认地址</p>
          <p v-else class="btn" @click="onDefault(item)">设为默认</p>
        </el-col>
      </el-row>
    </div>
    <AddressForm
      ref="form"
      :title="dlg.title"
      :address="form"
      :onConfirm="onDlgOk"
      @success="onSuccess"
    ></AddressForm>
  </div>
</template>

<script>
import EmptyNew from '@/components/EmptyNew';
import { triggerLoaded } from '@/components/LoadContainer.vue';
import AddressForm from '@stu/components/AddressForm.vue';
export default {
  name: 'member-address',
  components: {
    EmptyNew,
    AddressForm,
  },
  data() {
    return {
      form: null,
      list: [],
      dlg: {
        title: '添加地址',
        mode: 'add',
        id: '', // 编辑时候用于记录id
      },
    };
  },
  async created() {
    await this.requestList();
    triggerLoaded(this);
  },
  methods: {
    // on event
    onShowAddDlg() {
      this.$refs.form.showForm();
      this.dlg.title = '添加地址';
      this.dlg.mode = 'add';
    },
    onDlgOk(params) {
      if (this.dlg.mode == 'add') {
        return this.$http.post('/api/app/address', params);
      } else if (this.dlg.mode == 'modify') {
        return this.$http.put(`/api/app/address/${this.dlg.id}`, params);
      }
    },
    onSuccess() {
      this.$success(this.dlg.mode == 'add' ? '新增成功' : '修改成功', {
        duration: 1500,
      });
      this.requestList();
    },
    onModify(item) {
      this.dlg.title = '修改地址';
      this.dlg.mode = 'modify';
      this.dlg.id = item.id;
      this.$refs.form.showForm();
      this.form = {};
      this.form.province_id = item.province_id;
      this.form.city_id = item.city_id;
      this.form.district_id = item.district_id;
      this.form.address = item.address;
      this.form.zip_code = item.zip_code;
      this.form.user_name = item.user_name;
      this.form.mobile = item.mobile;
      this.form.is_default = item.is_default;
    },
    async onDelete(item) {
      await this.$promiseConfirm('确定要删除该收货地址吗？', {
        type: 'warning',
      });
      this.$http.delete(`/api/app/address/${item.id}`).then(() => {
        this.$success('删除成功', {
          duration: 1500,
        });
        this.requestList();
      });
    },
    onDefault(item) {
      this.$http.put(`/api/app/address/status/${item.id}`).then(() => {
        this.$success('设置成功', {
          duration: 1500,
        });
        this.requestList();
      });
    },
    // request
    async requestList() {
      let data = await this.$http.get('/api/app/address');
      this.list = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-add {
  width: 124px;
  height: 27px;
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: $primary-color;
  line-height: 27px;
  padding: 0;
  border: none;
  &:hover {
    background-color: $primary-color;
    color: white;
  }
  ::v-deep {
    .el-icon-plus {
      font-weight: bold;
    }
    [class*='el-icon-'] + span {
      margin-left: 0;
    }
  }
}
.member-address {
  background-color: #f7f8fa;
  .list-wrapper {
    padding: 24px;
    margin: 20px 0;
    background-color: #fff;
    border-radius: 10px;
    .el-row .el-col {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .title {
      padding-bottom: 15px;
      border-bottom: 1px solid #e8e8e8;
      font-size: 14px;
      font-weight: 500;
      color: #262626;
    }
    .item {
      font-size: 14px;
      border: 1px solid #e1e1e1;
      position: relative;
      margin: 15px 0;
      &:last-child {
        margin: 0;
      }
      .el-col {
        min-height: 120px;
        border-right: 1px solid #e1e1e1;
        padding: 10px;
        &:last-child {
          border-right: none;
        }
      }
      .action {
        flex-direction: column;
      }
      .btn {
        font-size: 15px;
        color: $primary-color;
        cursor: pointer;
      }
      .default {
        font-size: 15px;
        color: #8c8c8c;
        .tag-default {
          background-color: #f4f4f4;
          padding: 2px 8px;
          border-radius: 4px;
        }
      }
    }
  }
  .dlg {
    ::v-deep {
      .el-dialog__body {
        padding: 0 50px;
      }
      .el-dialog__header {
        padding: 32px 0;
        .el-dialog__headerbtn {
          top: 37px;
          right: 50px;
        }
        .el-dialog__close {
          font-weight: bold;
        }
        .el-dialog__title {
          height: 24px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(89, 89, 89, 1);
          line-height: 24px;
        }
      }
      .el-form-item {
        margin-bottom: 38px;
      }
      .el-dialog__footer {
        padding: 0 50px 32px 50px;
      }
      .dlg-footer {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
